import React, { memo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import TimeRemaining from './TimeRemaining';
import { t } from '../../services/i18nService';
import styles from './header.scss';
import headerNotificationsSelector from '../../selectors/header/HeaderNotificationsSelector';
import SidebarButton from './buttons/SidebarButton';
import OptionsMenuButton from './buttons/OptionsMenuButton';
import LivestreamStatus from './LivestreamStatus';
import MessageButton from './buttons/MessageButton';
import ConnectionStatus from './ConnectionStatus';
import ChatButton from './buttons/ChatButton';
import OwnPreviewSwitcher from './buttons/OwnPreviewSwitcher';

const HeaderTopBar = (props) => {
    const {
        assetRoot,
        candidateInfoString,
        connectionStatus,
        finalMinutesMode,
        hasDelivered,
        isChatEnabled,
        isNoteTakingAndHighlightingEnabled,
        logoPath,
        offlineMode,
        oneMinuteRemaining,
        pauseTime,
        remainingTimePrimaryEndTime,
        showEndTimePostPrimaryEndTime,
        showLivestreamStatus,
        showMessagesButton,
        showOwnPreviewSwitcher,
        showRecordingNotification,
        showTimeRemaining,
        timeRemaining,
        ui,
    } = props;

    const topBarClass = styles.topbar + (oneMinuteRemaining ? ` ${styles.oneMinuteRemaining}` : '');

    return (
        <div className={topBarClass} id="headerTopBar">
            { logoPath &&
                <div className={styles.logo}>
                    <img src={!assetRoot ? logoPath : `${assetRoot}/${logoPath}`} alt={t('header.logo')} />
                </div>
            }

            <div className={styles.statusColor} />
            <div className={styles.statusText}>
                <div className={styles.name}>
                    {candidateInfoString}
                </div>

                <div>
                    { showTimeRemaining &&
                        <TimeRemaining
                            timeRemaining={timeRemaining}
                            finalMinutesMode={finalMinutesMode}
                            isInfinityCausedByLiveSession={showLivestreamStatus}
                            pauseTime={pauseTime}
                            remainingTimePrimaryEndTime={remainingTimePrimaryEndTime}
                            showEndTimePostPrimaryEndTime={showEndTimePostPrimaryEndTime}
                        />
                    }

                    { showRecordingNotification &&
                        <span className={`${styles.inlineSubHeaderText} ${styles.recordingSubHeaderText}`}>
                            <i className="fa fa-circle" aria-hidden />
                            <span className={styles.subHeaderTitle}>
                                {t('header.recording')}
                            </span>
                        </span>
                    }

                    { ui.backgroundAudioStarted &&
                        <span className={styles.inlineSubHeaderText}>
                            <i className="fa fa-volume-up" aria-hidden />
                            <span className={styles.subHeaderTitle}>
                                {t('session.backgroundAudioIsPlaying')}
                            </span>
                        </span>
                    }

                    { showLivestreamStatus && <LivestreamStatus /> }

                </div>

            </div>

            { showOwnPreviewSwitcher && <OwnPreviewSwitcher /> }

            <div className={styles.connectionAndButtonContainer}>
                <ConnectionStatus connectionStatus={connectionStatus} offlineMode={offlineMode} />
                { showMessagesButton && <MessageButton isDisabled={!!pauseTime} /> }
                { !hasDelivered && <OptionsMenuButton ui={ui} isDisabled={!!pauseTime} /> }
                { isChatEnabled && <ChatButton /> }
                { isNoteTakingAndHighlightingEnabled && <SidebarButton isDisabled={!!pauseTime} /> }
            </div>
        </div>
    );
};

HeaderTopBar.propTypes = {
    assetRoot: PropTypes.string.isRequired,
    candidateInfoString: PropTypes.string.isRequired,
    connectionStatus: PropTypes.string,
    finalMinutesMode: PropTypes.bool,
    hasDelivered: PropTypes.bool.isRequired,
    isChatEnabled: PropTypes.bool.isRequired,
    isNoteTakingAndHighlightingEnabled: PropTypes.bool.isRequired,
    logoPath: PropTypes.string,
    offlineMode: PropTypes.bool.isRequired,
    oneMinuteRemaining: PropTypes.bool.isRequired,
    pauseTime: PropTypes.number,
    remainingTimePrimaryEndTime: PropTypes.number,
    showEndTimePostPrimaryEndTime: PropTypes.bool.isRequired,
    showLivestreamStatus: PropTypes.bool.isRequired,
    showMessagesButton: PropTypes.bool.isRequired,
    showOwnPreviewSwitcher: PropTypes.bool.isRequired,
    showRecordingNotification: PropTypes.bool.isRequired,
    showTimeRemaining: PropTypes.bool.isRequired,
    timeRemaining: PropTypes.number,
    ui: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    return headerNotificationsSelector.selectProps(state, ownProps);
};

const HeaderNotifications = memo(connect(mapStateToProps)(HeaderTopBar));

export default HeaderNotifications;
